import BaseKinesisEvent from './BaseKinesisEvent';

class RegisterCompleteEvent extends BaseKinesisEvent {
  constructor(private readonly host_id: string) {
    super('register_complete', 'register_form_host_info');
  }
}

export default RegisterCompleteEvent;
